'use client';

import { toast } from 'react-toastify';
import { useTransition } from 'react';
import { X } from 'lucide-react';

import { useCartStore } from '@lib/stores/useCartStore';
import { removeProductToCart } from '@lib/cart/actions';
import { Product } from '@lib/product/definitions';
import { capitalizedPerWord } from '@lib/utils';
import { CacheTags } from '@lib/tags';

interface RemoveCartProductProps {
  product: Product;
}

export function RemoveCartProduct({
  product,
}: Readonly<RemoveCartProductProps>) {
  const { cart, setCart } = useCartStore();
  const [loading, startTransition] = useTransition();

  const handleRemoveProductToCart = () => {
    if (!cart) return;

    startTransition(() => {
      removeProductToCart({
        cartId: cart.id,
        productId: product.id,
        tags: [CacheTags.Cart],
      })
        .then((cart) => {
          setCart(cart);
          toast.success(
            `Product ${capitalizedPerWord(product.name)} removed to cart!`,
          );
        })
        .catch((error) => {
          console.error('removeProductToCart error: ', error);
          toast.error((error as Error).message);
        });
    });
  };

  return (
    <button
      className='flex-none flex-center text-gray-400 hover:text-primary'
      disabled={loading}
      onClick={handleRemoveProductToCart}
    >
      <X className='h-5 w-5' aria-hidden='true' />
      <span className='sr-only'>Remove</span>
    </button>
  );
}
